<template>
  <router-view/>
  <AppPopup/>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useHead } from '@vueuse/head'
import { useI18n } from 'vue-i18n'
import axios from 'axios'
import AppPopup from '@/components/AppPopup.vue'
import { useHtmlLang } from '@/composables/useHtmlLang'

const { locale } = useI18n()
const route = useRoute()

useHtmlLang()

const seo = ref({
  title: 'Ruqm Platform|Exhibitions,Business Events&Digital Networking',
  description: 'Ruqm Platform connects exhibitions, companies, and visitors through a digital hub offering details, networking tools, and international exposure',
  keywords: ['Ruqm Platform', 'Exhibitions Directory','Trade Events','Digital Exhibitions']
})

const canonicalUrl = computed(() =>
  `https://ruqm.me${route.path}`
)

const fetchGlobalSeo = async () => {
  try {
    const response = await axios.get(`/seo-settings?lang=${locale.value}`)
    if (response.data.success) {
      const data = response.data.data
      seo.value = {
        title: data.title || 'Ruqm',
        description: data.description || 'Ruqm',
        keywords: data.focus_keywords || []
      }
    }
  } catch (error) {
    console.error(error)
  }
}

watch(locale, fetchGlobalSeo, { immediate: true })
// const supportedLocales = ['en', 'ar']

// const hreflangLinks = computed(() => {
//   const pathWithoutLang = route.path.replace(/^\/(en|ar)/, '')

//   return supportedLocales.map(lang => ({
//     rel: 'alternate',
//     hreflang: lang,
//     href: `https://ruqm.me/${lang}${pathWithoutLang}`
//   }))
// })

// const xDefault = computed(() => ({
//   rel: 'alternate',
//   hreflang: 'x-default',
//   href: `https://ruqm.me/en${route.path.replace(/^\/(en|ar)/, '')}`
// }))

useHead(() => ({
  title: seo.value.title,
  meta: [
    { name: 'description', content: seo.value.description || '' },
    { name: 'keywords', content: seo.value.keywords.join(', ') },

    // Open Graph
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: canonicalUrl.value },
    { property: 'og:title', content: seo.value.title },
    { property: 'og:description', content: seo.value.description },
    { property: 'og:image', content: seo.value.image },
    { property: 'og:site_name', content: 'Ruqm Exhibition Platform' },

    // Twitter
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: seo.value.title },
    { name: 'twitter:description', content: seo.value.description },
    { name: 'twitter:image', content: seo.value.image },
  ],
  link: [
    { rel: 'canonical', href: canonicalUrl.value },
    // ...hreflangLinks.value,
    // xDefault.value
  ],
  script :[
    {
    type: "application/ld+json",
    children: JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Ruqm",
    "url": "https://ruqm.me/",
    "logo": "https://ruqm.me/logo1.webp",
    "sameAs": [
      "https://www.facebook.com/ruqm.me",
      "https://www.linkedin.com/company/ruqm/"
    ]
    }),
      key: "schema"
    }
  ]
}))
</script>
